import { css } from 'styled-components';
// stylelint-disable
const vendorCSS = css`
  position: relative;

  /* Swiper v7+ renamed .swiper-container to .swiper */
  .swiper {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
  }

  .swiper-no-flexbox .swiper-slide {
    float: left;
  }

  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }

  .swiper-slide {
    margin-bottom: 50px;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }

  .swiper-slide-invisible-blank {
    visibility: hidden;
  }

  .swiper-autoheight {
    height: auto;
    .swiper-slide {
      height: auto;
    }
    .swiper-wrapper {
      align-items: flex-start;
      transition-property: transform, height;
    }
  }

  .swiper-button-lock {
    display: none;
  }

  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
    &.swiper-pagination-hidden {
      opacity: 0;
    }
  }

  .swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
    .swiper-pagination-bullet {
      transform: scale(0.33);
      position: relative;
    }
    .swiper-pagination-bullet-active,
    .swiper-pagination-bullet-active-main {
      transform: scale(1);
    }
    .swiper-pagination-bullet-active-prev {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-prev-prev {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet-active-next {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-next-next {
      transform: scale(0.33);
    }
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
  }

  button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    appearance: none;
  }

  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
  }

  .swiper-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    background: ${(props) => props.theme.color.primary800};
  }

  .swiper-horizontal {
    > .swiper-pagination-bullets {
      .swiper-pagination-bullet {
        margin: 0 10px;
        opacity: 1;
        background: ${(props) => props.theme.color.gray500};
      }
      &.swiper-pagination-bullets-dynamic {
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        .swiper-pagination-bullet {
          transition:
            200ms left,
            200ms transform;
        }
      }
    }
  }

  .swiper-pagination-lock {
    display: none;
  }

  .swiper .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000;
  }

  .swiper-fade {
    .swiper-slide {
      pointer-events: none;
      transition-property: opacity;
    }
    .swiper-slide-active {
      pointer-events: auto;
    }
  }

  .swiper-cube {
    overflow: visible;
    .swiper-slide {
      pointer-events: none;
      backface-visibility: hidden;
      z-index: 1;
      visibility: hidden;
      transform-origin: 0 0;
      width: 100%;
      height: 100%;
    }
    .swiper-slide-active {
      pointer-events: auto;
      visibility: visible;
    }
    .swiper-slide-next,
    .swiper-slide-prev,
    .swiper-slide-next + .swiper-slide {
      pointer-events: auto;
      visibility: visible;
    }
    .swiper-cube-shadow {
      position: absolute;
      left: 0;
      bottom: 0px;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.6;
      filter: blur(50px);
      z-index: 0;
    }
  }

  .swiper-flip {
    overflow: visible;
    .swiper-slide {
      pointer-events: none;
      backface-visibility: hidden;
      z-index: 1;
    }
    .swiper-slide-active {
      pointer-events: auto;
    }
  }

  .swiper-coverflow .swiper-wrapper {
    -ms-perspective: 1200px;
  }
`;
// stylelint-enable

export default vendorCSS;
